import * as React from "react";
import Card from '@material-ui/core/Card';
import { Form } from 'react-final-form';
import { makeStyles } from "@material-ui/core/styles";
import { Box, Button, CardActions, CircularProgress, Theme, Typography } from "@material-ui/core";
import {
    email,
    Notification,
    required,
    TextInput, useNotify,
} from "react-admin";
import StandardApiError from "shared/errors/standardApiError";
import { useSafeSetState } from "ra-core";
import { useTranslation } from "react-i18next";
import { mutateRequestPasswordReset } from "api/mutations/requestPasswordReset";

const useStyles = makeStyles(
    (theme: Theme) => ({
        main: {
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            alignItems: 'center',
            justifyContent: 'flex-start',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundImage:
                'radial-gradient(circle at 50% 14em, #313264 0%, #00023b 60%, #00023b 100%)',
        },
        card: {
            width: 300,
            marginTop: '6em',
            marginBottom: '6em',
        },
        button: {
            width: '100%',
        },
        icon: {
            marginRight: theme.spacing(1),
        },
    }),
);

const ForgotPassword = (props: {}) => {
    const classes = useStyles(props);
    const [saving, setSaving] = useSafeSetState(false);
    const [sent, setSent] = useSafeSetState(false);
    const notify = useNotify();
    const { t } = useTranslation();

    const save = React.useCallback(
        async (values) => {
            try {
                setSaving(true);
                await mutateRequestPasswordReset(values);
                setSaving(false);
                setSent(true);
            } catch (error) {
                setSaving(false);
                if (error instanceof StandardApiError) {
                    error.requestErrors.forEach(error => notify(error, {type: 'error'}));
                    return error.validationErrors;
                }
            }
        },
        [setSaving, setSent, notify]
    );

    return (
        <div
            className={classes.main}
        >
            <Card className={classes.card}>
                {!sent && <Form
                    onSubmit={save}
                    render={({ handleSubmit }) => (
                        <form onSubmit={handleSubmit} noValidate>
                            <Box pt="1em" pl="1em" pr="1em">
                                <Typography variant="h5" align="center" gutterBottom>
                                    {t('forgot.forgotPassword')}
                                </Typography>

                                <Typography align="center">
                                    {t('forgot.enterYourEmail')}
                                </Typography>

                                <TextInput label={t('signUp.emailAddress')} source="emailAddress" validate={[required(), email()]} fullWidth disabled={saving} />
                            </Box>
                            <CardActions>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    color="primary"
                                    disabled={saving}
                                    className={classes.button}
                                >
                                    {saving && (
                                        <CircularProgress
                                        className={classes.icon}
                                            size={18}
                                            thickness={2}
                                        />
                                    )}
                                    {t('forgot.continue')}
                                </Button>
                            </CardActions>
                        </form>
                    )}
                />}
                {sent && <>
                    <Box p={1} mt={2}>
                        <Typography variant="h5" align="center">
                            {t('forgot.forgotPassword')}
                        </Typography>
                    </Box>
                    <Box p={1} mt={2} mb={2}>
                        <Typography align="center">
                            {t('forgot.emailHasBeenSend')}
                        </Typography>
                    </Box>
                </>}
            </Card>
            <Notification />
        </div>
    );
}

export default ForgotPassword;